export default __webpack_public_path__ + "static/media/popcorn.cbd83c02.jpg";